/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Navsignout2Inputs */

const en_navsignout2 = /** @type {(inputs: Navsignout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign out`)
};

const pt_navsignout2 = /** @type {(inputs: Navsignout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sair`)
};

/**
* | output |
* | --- |
* | "Sign out" |
*
* @param {Navsignout2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const navsignout2 = /** @type {((inputs?: Navsignout2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Navsignout2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_navsignout2(inputs)
	return pt_navsignout2(inputs)
});
export { navsignout2 as "navSignOut" }